<template>
	<BaseLoading
		v-if="isLoading"
	/>
	<BaseTabBar
		v-else
		v-model="tabActiveAtIndex"
	>
		<CTab
			v-for="(tab, index) in tabs"
			:key="index"
			:title="tab.name"
		>
			<AllocationOnlineGroupList
				:id="tab.id"
				:is-loading="isLoading"
				:pagination="pagination"
				:table-data="tableData"
				:branch-ids="selectedBranchIds"
				:temporary-branches="tempBranches"
				:query="query"
				@onDone="onSelectBranchDone"
			/>
		</CTab>
	</BaseTabBar>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { cleanObject, cloneDeep } from '../helpers/utils';

export default {
	name: 'AllocationOnlineGroup',

	data() {
		return {
			query: {
				tab: this.$route.query.tab,
				sort_by: this.$route.query.sort_by || null,
				sort_direction: this.$route.query.sort_direction || null,
			},
			tabActiveAtIndex: 0,
			masterTabs: {},
			tempBranches: [],
			isLoading: false,
		};
	},

	computed: {
		...mapState('branchGroupList', {
			isLoadingTabs: 'isLoading',
			tabs: 'data',
		}),
		...mapState('branchGroupAssignList', {
			isLoadingBranches: 'isLoading',
			pagination: 'pagination',
			data: 'data',
		}),
		...mapGetters('branchGroupAssignList', {
			tableData: 'tableData',
		}),
		selectedBranchIds() {
			return this.data.map((item) => ({
				id: item.id,
			}));
		},
	},

	watch: {
		tabActiveAtIndex() {
			this.query.tab = this.masterTabs[this.tabActiveAtIndex];
		},
		query: {
			handler() {
				this.updateUrl();
			},
			deep: true,
		},
	},

	async created() {
		this.isLoading = true;
		await this.fetchData();
		this.isLoading = false;
	},

	methods: {
		...mapActions('branchGroupList', {
			getBranchGroups: 'getBranchGroups',
		}),
		...mapActions('branchGroupAssignList', {
			getBranchGroupAssign: 'getBranchGroupAssign',
		}),
		...mapActions('branchGroupAssignUpdate', {
			updateGroupBranchAssign: 'updateGroupBranchAssign',
		}),
		async fetchData() {
			await this.getBranchGroups();

			this.masterTabs = {};
			this.tabs.forEach((tab, index) => {
				this.masterTabs[index] = tab.id;
			});

			const tabIndex = this.getTabIndex(this.$route.query.tab);
			if (tabIndex > 0) {
				this.tabActiveAtIndex = tabIndex;
			}

			await this.getBranchGroupAssign({
				id: this.query.tab || Object.values(this.masterTabs)[0],
				params: {
					per_page: 'all',
					...this.query,
					tab: null,
				},
			});

			this.tempBranches = [];
			setTimeout(() => {
				this.tempBranches = this.data.map((branch) => {
					return {
						branch_id: branch.itecBranchId,
						branch_id_of_im: branch.id,
					};
				});
			}, 100);
		},
		getTabIndex(tabValue) {
			if (!tabValue || this.masterTabs === undefined) {
				return 0;
			}

			const index = Object.values(this.masterTabs).findIndex((value) => Number(value) === Number(tabValue));
			return index === -1
				? 0 // default as 0
				: index;
		},
		updateUrl() {
			const query = cleanObject(cloneDeep(this.query));
			this.$router.push({ query }).catch(() => {});
		},
		async onSelectBranchDone(values = []) {
			const branchIds = values.map((branch) => branch.id);
			this.isLoading = true;
			await this.updateGroupBranchAssign({
				id: this.query.tab || Object.values(this.masterTabs)[0],
				params: {
					branch_ids: branchIds,
				},
			});
			await this.fetchData();
			this.isLoading = false;
		},
	},
};
</script>